import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    missing: {
        borderLeft: `3px solid ${tokens.colorPaletteRedBorder2}`,
        backgroundColor: tokens.colorPaletteRedBackground1,
        borderRadius: tokens.borderRadiusMedium,
        padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    },
    hint: {
        fontSize: '11px',
        fontWeight: 600,
        color: tokens.colorPaletteRedForeground1,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
});

interface RequiredFieldFrameProps {
    isMissing: boolean;
    children: React.ReactNode;
}

const RequiredFieldFrame: React.FC<RequiredFieldFrameProps> = ({ isMissing, children }) => {
    const styles = useStyles();

    if (!isMissing) {
        return <>{children}</>;
    }

    return (
        <div className={styles.missing} role="group" aria-label="Required field not set">
            <div className={styles.hint}>Required – not set</div>
            {children}
        </div>
    );
};

export default RequiredFieldFrame;
